import { Component, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { CommonDoctorModel } from 'src/app/model/common/doctor';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';
import { DOCTOR } from '../doctor.constants';
import { DoctorService } from '../doctor.service';

@Component({
  selector: 'ms-common-doctor-form',
  templateUrl: './doctor-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DoctorFormComponent,
      multi: true,
    },
  ],
})
export class DoctorFormComponent
  extends BaseValueAccessor<CommonDoctorModel>
  implements OnInit
{
  readonly screen = DOCTOR;
  locations: SelectItem<KhuyanaSelectItemModel>[] = [];
  residenceHelp: SelectItem<KhuyanaSelectItemModel> = { value: {} };

  constructor(protected service: DoctorService) {
    super();
  }

  ngOnInit(): void {
    if (!this.value) {
      this.value = {};
    }
    const { locations, doctorData, residence } = this.service.readStore();
    doctorData.subscribe((result) => this.service.setDoctorInformation(result));
    locations.subscribe((result) => (this.locations = result));
    residence.subscribe((result) => (this.residenceHelp = result));
  }

  queryLocations = (query: string) =>
    this.service.readLocations(query).subscribe();

  verifyResidence = () => {
    const isNotValidLocation =
      this.residenceHelp == null ||
      this.residenceHelp.value == null ||
      this.residenceHelp.value.id == null;
    if (isNotValidLocation) {
      delete this.value.residence;
    }
  };
}
